<script>
	import VoucherPartecipantModulesContainer from './VoucherPartecipantModulesContainer'
	import VoucherPartecipantProvince from './VoucherPartecipantProvince'
	import VoucherPartecipantMunicipality from './VoucherPartecipantMunicipality'
	import VoucherPartecipantCountry from './VoucherPartecipantCountry'
	import ProvinceMunicipality from './ProvinceMunicipality'
	import VoucherPartecipantPhonePrefix from '../purchases/VoucherPartecipantPhonePrefix'
	import VoucherPartecipantsModuleRequestOtp from './VoucherPartecipantsModuleRequestOtp'	
	import {Form} from '../../helpers/Form/Form'

	export default {
		props: {
			element: Number
		},
		components: {
			VoucherPartecipantModulesContainer,
			VoucherPartecipantMunicipality,
			VoucherPartecipantProvince,
			VoucherPartecipantCountry,
			ProvinceMunicipality,
			VoucherPartecipantPhonePrefix,
			VoucherPartecipantsModuleRequestOtp
		},
		data() {
			return {
				common_fields: [],
				view: 'general',
				company: {},
				purchaseElement: {},
				buyable: {},
				fiscalFile: {},
				course: null,
				modules: [],
				purchaseElements: null,
				fetch: new Form({}),
                invoiceErrorsData: [],
				form: new Form({
					id: null,
					view: 'general',
					currentNavLink: 0,
					is_complete: false,
					validate_invoice: false,
					accept_promotions: false,
					responsible_terms: false,
					partecipants: [],
                    invoice_form: {
						invoice_first_name: null,
						invoice_last_name: null,
						invoice_email: null,
						invoice_phone_prefix: "+39",
						invoice_phone: null,
						invoice_birthday: null,
						invoice_fiscal_code: null,
						invoice_address: null,
						invoice_house_number: null,
						invoice_postal_code: null,
						invoice_municipality: null,
						invoice_country: null,
						invoice_province: null,
						invoice_nationality: null,
						obj_province: null,
						obj_municipality: null                    	
                    },
                    phone: null,
                    otp: null,
                    submitted: false
				})
			}
		},
		computed: {
			hasUnder() {
				return this.form.partecipants.filter(i => i.is_under).length > 0
			},
			canConfirm() {
				let partecipants = this.form.partecipants.filter(i => {
					if (i.is_under) {
						return _.isEmpty(i.first_name) || _.isEmpty(i.last_name) || _.isEmpty(i.birthday)
							|| _.isEmpty(i.responsible_first_name) || _.isEmpty(i.responsible_last_name)
							|| _.isEmpty(i.responsible_email)
					}
					return _.isNull(i.first_name) || _.isNull(i.last_name) || _.isNull(i.birthday)
				})
				if (this.hasUnder) {
					return partecipants.length == 0 && this.form.responsible_terms
				}
				return partecipants.length == 0
			},
            responsibleMaxYear() {
                let now = moment()
                return now.year() - 18
            },
            isSubscription() {
                if (this.element) {
                    return this.purchaseElement.buyable_type === "App\\CourseSubscription"
                }
                return false
            },
            isLessonPackage() {
                if (this.element) {
                    return this.purchaseElement.buyable_type === "App\\LessonPackage"
                }
                return false
            },
            isFee() {
                if (this.element) {
                    return this.purchaseElement.buyable_type === "App\\CompanyFee"
                }
                return false
            },
            isPromotion() {
                if (this.element) {
                    return this.purchaseElement.buyable_type === "App\\CoursePromotion"
                }
                return false
            },
            promoDescription() {
                if (this.isPromotion) {
                    let textType = this.purchaseElement.buyable.lesson_type == 'group' ? 'di gruppo' : 'individuali'
                    return `${this.purchaseElement.buyable.lessons} lezioni ${textType} per ${this.purchaseElement.buyable.people} persone`
                }
                return null
            },
            isFormCompletelyEmpty() {
                const partecipantsEmpty = this.form.partecipants.length === 0;
                const invoiceEmpty = Object.values(this.form.invoice_form).every(val => val === null || val === '');
                const otherFieldsEmpty = (this.form.phone === null || this.form.phone === '') &&
                    (this.form.otp === null || this.form.otp === '');

                return partecipantsEmpty && invoiceEmpty && otherFieldsEmpty;
            }
		},
		watch: {
			'form.invoice_form.invoice_nationality': {
				handler(val) {
                    const cc = this.getInvoiceCountryComponent()
                    if(cc) {
                        if(val == 'italian' || val == 'foreign') {
							let selectVal = null

                            if (val == 'italian') {
                                selectVal = 'ITALIA'
                            }

                            if(selectVal) {
                                const $select = cc.getSelect()
                                $select.val(selectVal)
                                cc.setSelectedValue(selectVal)
                            }
							
							this.$set(this.form.invoice_form, 'invoice_country', selectVal)

							this.changedCountry(selectVal)
                        }
                    }
                }
			},
			'form.invoice_form.invoice_country': {
                handler(val) {
                    if(val) {
                        this.changedCountry(val)
                    }
                }
            },
			'form.invoice_form.invoice_province': {
				handler(val) {
					if(val) {
						this.changedProvince(val)
					}
				}
			},
			'form.invoice_form.invoice_municipality': {
				handler(val) {
					this.changedMunicipality(val)
				}
			},
			'form.invoice_form.invoice_phone_prefix': {
				handler(val) {
					this.changedPrefix(val)
				}
			}
		},
		mounted() {
			this.getPurchaseElement()

			this.$bus.$on('module.skipped', ({m_idx,p_idx,value}) => {
				this.$set(this.form.partecipants[p_idx].modules[m_idx], 'skip', value)
			})			
			this.$bus.$on('submit-subscription', this.onValidateSubscription)
			this.$bus.$on('next-to', this.nextTo)
			this.$bus.$on('otp-sent', (payload) => {
				this.$set(this, 'sent', true)
				this.$set(this.form, 'phone', payload.phone)
			})			
		},
		methods: {
			// INVOICE FORM
			getInvoiceCountryComponent() {
				let cc = this.$refs.countrycomponent_invoice

				if(typeof(cc[0]) != 'undefined') {
					cc = cc[0]
				}

                return cc
            },
            getInvoiceProvinceMunicipalityComponent() {
				let pm = this.$refs.provincemunicipality_invoice

				if(typeof(pm[0]) != 'undefined') {
					pm = pm[0]
				}

                return pm
            },
            getInvoiceProvinceComponent() {
				const pm = this.getInvoiceProvinceMunicipalityComponent()
				if(pm) {
					return pm.getProvinceComponent()
				}
                
				return null
            },
            getInvoiceMunicipalityComponent() {
				const pm = this.getInvoiceProvinceMunicipalityComponent()
				if(pm) {
					return pm.getMunicipalityComponent()
				}
                
				return null
            },
			getInvoicePhonePrefixComponent() {
				let cc = this.$refs.prefixcomponent_invoice

				if(typeof(cc[0]) != 'undefined') {
					cc = cc[0]
				}

                return cc
            },
			getSelectedValueInvoiceCountry() {
                const cc = this.getInvoiceCountryComponent()
                if(cc) {
                    return cc.getSelectedValue()
                }
                    
                return ''
            },
            getSelectedValueInvoiceProvince() {
                const pc = this.getInvoiceProvinceComponent()
                if(pc) {
                    return pc.getSelectedValue()
                }

                return ''
            },
            getSelectedValueInvoiceMunicipality() {
                const mc = this.getInvoiceMunicipalityComponent()
                if(mc) {
                    return mc.getSelectedValue()
                }

                return ''
            },
			getSelectedValueInvoicePhonePrefix() {
                const cc = this.getInvoicePhonePrefixComponent()
                if(cc) {
                    return cc.getSelectedValue()
                }
                    
                return ''
            },
			setSelectedValueInvoiceCountry() {                
                this.$set(this.form.invoice_form, 'invoice_country', this.form.invoice_form.nationality == 'italian' ? 'ITALIA' : this.getSelectedValueInvoiceCountry())
            },
            setSelectedValueInvoiceProvince() {
                this.$set(this.form.invoice_form, 'invoice_province', this.form.invoice_form.nationality == 'foreign' ? '' : this.getSelectedValueInvoiceProvince())
            },
            setSelectedValueInvoiceMunicipality() {
                this.$set(this.form.invoice_form, 'invoice_municipality', this.getSelectedValueInvoiceMunicipality())
            },
			setSelectedValueInvoicePhonePrefix() {
                this.$set(this.form.invoice_form, 'invoice_phone_prefix', this.getSelectedValueInvoicePhonePrefix())
            },
			// PARTECIPANT FORM
			getPartecipantCountryComponent(idx=0, responsible=false) {
				let key = 'countrycomponent_'
				if(responsible) {
					key += 'responsible_'
				}

				let cc = this.$refs[`${key}${idx}`]
				if(typeof(cc[0]) != 'undefined') {
					cc = cc[0]
				}

                return cc
            },
            getPartecipantProvinceMunicipalityComponent(idx=0, responsible=false) {
                let key = 'provincemunicipality_'
				if(responsible) {
					key += 'responsible_'
				}

				let pm = this.$refs[`${key}${idx}`]
				if(typeof(pm[0]) != 'undefined') {
					pm = pm[0]
				}

                return pm
            },
            getPartecipantProvinceComponent(idx=0, responsible=false) {
				let pm = this.getPartecipantProvinceMunicipalityComponent(idx, responsible)
				if(pm) {
                	return pm.getProvinceComponent()
				}

				return null
            },
            getPartecipantMunicipalityComponent(idx=0, responsible=false) {
                const pm = this.getPartecipantProvinceMunicipalityComponent(idx, responsible)
				if(pm) {
                	return pm.getMunicipalityComponent()
				}

				return null
            },
			getPartecipantPhonePrefixComponent(idx=0, responsible=false) {
				let key = 'prefixcomponent_'
				if(responsible) {
					key += 'responsible_'
				}

				let cc = this.$refs[`${key}${idx}`]
				if(typeof(cc[0]) != 'undefined') {
					cc = cc[0]
				}

                return cc
            },
			getSelectedValuePartecipantCountry(idx=0, responsible=false) {
                const cc = this.getPartecipantCountryComponent(idx, responsible)
                if(cc) {
                    return cc.getSelectedValue()
                }
                    
                return ''
            },
            getSelectedValuePartecipantProvince(idx=0, responsible=false) {
                const pc = this.getPartecipantProvinceComponent(idx, responsible)
                if(pc) {
                    return pc.getSelectedValue()
                }

                return ''
            },
            getSelectedValuePartecipantMunicipality(idx=0, responsible=false) {
                const mc = this.getPartecipantMunicipalityComponent(idx, responsible)
                if(mc) {
                    return mc.getSelectedValue()
                }

                return ''
            },
			getSelectedValuePartecipantPhonePrefix(idx=0, responsible=false) {
                const cc = this.getPartecipantPhonePrefixComponent(idx, responsible)
                if(cc) {
                    return cc.getSelectedValue()
                }
                    
                return ''
            },
			setSelectedValuePartecipantCountry(idx=0, responsible=false) { 
                this.$set(this.partecipants[idx], (responsible ? 'responsible_' : '') + 'country', this.partecipants[idx]['nationality'] == 'italian' ? 'ITALIA' : this.getSelectedValuePartecipantCountry(idx, responsible))
            },
            setSelectedValuePartecipantProvince(idx=0, responsible=false) {
                this.$set(this.partecipants[idx], (responsible ? 'responsible_' : '') + 'province', this.partecipants[idx]['nationality'] == 'foreign' ? '' : this.getSelectedValuePartecipantProvince(idx, responsible))
            },
            setSelectedValuePartecipantMunicipality(idx=0, responsible=false) {
                this.$set(this.partecipants[idx], (responsible ? 'responsible_' : '') + 'municipality', this.getSelectedValuePartecipantMunicipality(idx, responsible))
            },
			setSelectedValuePartecipantPhonePrefix(idx=0, responsible=false) {
                this.$set(this.partecipants[idx], (responsible ? 'responsible_' : '') + 'phone_prefix', this.getSelectedValuePartecipantPhonePrefix(idx, responsible))
            },
            adjustFormData() {
                this.setSelectedValueInvoiceCountry()
                this.setSelectedValueInvoiceProvince()
                this.setSelectedValueInvoiceMunicipality()
				this.setSelectedValueInvoicePhonePrefix()

				this.form.partecipants.forEach((i, idx) => {
					this.setSelectedValuePartecipantCountry(idx, false)
					this.setSelectedValuePartecipantCountry(idx, true)
					
					this.setSelectedValuePartecipantProvince(idx, false)
					this.setSelectedValuePartecipantProvince(idx, true)
					
					this.setSelectedValuePartecipantMunicipality(idx, false)
					this.setSelectedValuePartecipantMunicipality(idx, true)

					this.setSelectedValuePartecipantPhonePrefix(idx, false)
					this.setSelectedValuePartecipantPhonePrefix(idx, true)
				})
            },
			async getPurchaseElement() {
				let {purchaseElement, fiscalFile, element, modules, common_fields} = await this.fetch.get(route('purchaseElement.show', this.element))
				this.$set(this, 'common_fields', common_fields)
				this.$set(this, 'modules', modules)
				this.$set(this, 'fiscalFile', fiscalFile)
				this.$set(this, 'company', element[0].company)
				this.$set(this, 'purchaseElement', purchaseElement)
				this.$set(this, 'buyable', purchaseElement.buyable)
				this.$set(this, 'course', element[0].course)

				this.setInvoiceData(fiscalFile)
				this.setPartecipant(fiscalFile)	
			},	
			setInvoiceData(fiscalFile) {
				this.$set(this.form.invoice_form, 'invoice_first_name', fiscalFile.first_name)
				this.$set(this.form.invoice_form, 'invoice_last_name', fiscalFile.last_name)
				this.$set(this.form.invoice_form, 'invoice_email', fiscalFile.email)
				this.$set(this.form.invoice_form, 'invoice_birthday', fiscalFile.born)
				this.$set(this.form.invoice_form, 'invoice_fiscal_code', fiscalFile.fiscal_code)
				this.$set(this.form.invoice_form, 'invoice_address', fiscalFile.address)
				this.$set(this.form.invoice_form, 'invoice_house_number', fiscalFile.house_number)
				this.$set(this.form.invoice_form, 'invoice_postal_code', fiscalFile.zip)
				this.$set(this.form.invoice_form, 'invoice_municipality', fiscalFile.municipality)
				this.$set(this.form.invoice_form, 'invoice_nationality', fiscalFile.nationality || 'italian')
				this.$set(this.form.invoice_form, 'invoice_country', fiscalFile.state)
				this.$set(this.form.invoice_form, 'invoice_province', fiscalFile.province)
				this.$set(this.form.invoice_form, 'obj_municipality', {
					name: fiscalFile.municipality,
					province: {
						long_name: fiscalFile.province
					}
				})
				this.$set(this.form.invoice_form, 'obj_province', {
					long_name: fiscalFile.province
				})

				let prefix = '+39'
				let phone = ''

				if (fiscalFile && fiscalFile.phone) {
					const pp = fiscalFile.phone.split(" ")

					if(pp && pp.length) {
						prefix = pp[0]
						if(pp.length == 2) {
							phone = pp[1]
						}
					}
				}

				this.$set(this.form.invoice_form, 'invoice_phone_prefix', prefix)
				this.$set(this.form.invoice_form, 'invoice_phone', phone)
			},
			setPartecipant(fiscalFile) {
				let prefix = '+39'
				let phone = ''

				if (fiscalFile && fiscalFile.phone) {
					const pp = fiscalFile.phone.split(" ")

					if(pp && pp.length) {
						prefix = pp[0]
						if(pp.length == 2) {
							phone = pp[1]
						}
					}
				}

				this.form.partecipants.push({
					its_me: true,
					email: fiscalFile.email,
					voucher_id: this.purchaseElement.voucher_id,
					validated: false,
					is_under: false,
					with_membership_fee: this.purchaseElement.with_membership_fee,
					first_name: fiscalFile.first_name,
					last_name: fiscalFile.last_name,
					birthday: fiscalFile.born,
					phone_prefix: prefix,
					phone: phone,
					fiscal_code: fiscalFile.fiscal_code,
					address: fiscalFile.address,
					house_number: fiscalFile.house_number,
					postal_code: fiscalFile.zip,
					municipality: fiscalFile.municipality,
					country: fiscalFile.state,
					province: fiscalFile.province,
					obj_municipality: {
						name: fiscalFile.municipality,
						province: {
							long_name: fiscalFile.province
						}
					},
					obj_province: {
						long_name: fiscalFile.province
					},					
					responsible_first_name: null,
					responsible_last_name: null,
					responsible_birthday: null,
					responsible_phone_prefix: prefix,
					responsible_phone: phone,
					responsible_address: null,
					responsible_house_number: null,
					responsible_postal_code: null,
					responsible_municipality: null,
					responsible_country: fiscalFile.state,
					responsible_province: null,
					responsible_obj_municipality: null,
					responsible_obj_province: null,					
					responsible_fiscal_code: null,
					responsible_email: null,
					responsible_terms: false,
					nationality: fiscalFile.nationality || 'italian',
					responsible_nationality: fiscalFile.nationality || 'italian',
					modules: this.modules
				})		

                if (this.purchaseElement.is_gift) {
                	this.$set(this.form.partecipants[0], 'its_me', false)
                	this.$set(this.form.partecipants[0], 'email', null)
                	this.$set(this.form.partecipants[0], 'first_name', this.purchaseElement.gift_recipient_name)
                	this.$set(this.form.partecipants[0], 'last_name', null)
                	this.$set(this.form.partecipants[0], 'birthday', null)
                }

				this.form.partecipants.forEach((i, idx) => {
					this.$watch(`form.partecipants.${idx}.birthday`, (val) => {
						this.updatePartecipant(this, val, idx)
					})

					this.$watch(`form.partecipants.${idx}.nationality`, (val) => {
						const cc = this.getPartecipantCountryComponent(idx, false)
						if(cc) {
							if(val == 'italian' || val == 'foreign') {
								let selectVal = null
								if (val == 'italian') {
									selectVal = 'ITALIA'
								}

								if(selectVal) {
									const $select = cc.getSelect()
									$select.val(selectVal)
									cc.setSelectedValue(selectVal)
								}

								this.$set(this.form.partecipants[idx], 'country', selectVal)

								this.changedCountry(selectVal, idx)
							}
						}
					})		

					this.$watch(`form.partecipants.${idx}.responsible_nationality`, (val) => {
						const cc = this.getPartecipantCountryComponent(idx, true)
						if(cc) {
							if(val == 'italian' || val == 'foreign') {
								let selectVal = null
								if (val == 'italian') {
									selectVal = 'ITALIA'
								}

								if(selectVal) {
									const $select = cc.getSelect()
									$select.val(selectVal)
									cc.setSelectedValue(selectVal)
								}

								this.$set(this.form.partecipants[idx], 'responsible_country', selectVal)

								this.changedCountry(selectVal, idx, true)
							}
						}
					})

					this.$watch(`form.partecipants.${idx}.country`, (val) => {
						if(val) {
							this.changedCountry(val, idx)
						}
                	})

					this.$watch(`form.partecipants.${idx}.responsible_country`, (val) => {
						if(val) {
							this.changedCountry(val, idx, true)
						}
                	})

					this.$watch(`form.partecipants.${idx}.province`, (val) => {
						if(val) {
							this.changedProvince(val, idx)
						}
					})

					this.$watch(`form.partecipants.${idx}.responsible_province`, (val) => {
						if (val) {
							this.changedProvince(val, idx, true)
						}
					})

					this.$watch(`form.partecipants.${idx}.municipality`, (val) => {
						if (val) {
							this.changedMunicipality(val, idx)
						}
					})

					this.$watch(`form.partecipants.${idx}.responsible_municipality`, (val) => {
						if (val) {
							this.changedMunicipality(val, idx, true)
						}
					})

					this.$watch(`form.partecipants.${idx}.phone_prefix`, (val) => {
						if (val) {
							this.changedPrefix(val, idx)
						}
					})

					this.$watch(`form.partecipants.${idx}.responsible_phone_prefix`, (val) => {
						if (val) {
							this.changedPrefix(val, idx, true)
						}
					})
				})			
			},
			updatePartecipant: _.debounce((vm, val, i) => {
				let now = moment()
				let current = moment(val, 'YYYY-MM-DD', true)

				if (current.isValid()) {
					vm.$set(vm.form.partecipants[i], 'is_under', now.diff(val, 'year') < 18)
					
					if (now.diff(val, 'year') >= 18) {
						vm.$set(vm.form.partecipants[i], 'responsible_first_name', null)
						vm.$set(vm.form.partecipants[i], 'responsible_last_name', null)
						vm.$set(vm.form.partecipants[i], 'responsible_phone_prefix', '+39')
						vm.$set(vm.form.partecipants[i], 'responsible_phone', null)
						if (vm.fiscalFile.born) {
							vm.$set(vm.form.partecipants[i], 'responsible_birthday', null)
						}
						vm.$set(vm.form.partecipants[i], 'responsible_email', null)
						vm.$set(vm.form.partecipants[i], 'responsible_fiscal_code', null)
						vm.$set(vm.form.partecipants[i], 'responsible_address', null)
						vm.$set(vm.form.partecipants[i], 'responsible_house_number', null)
						vm.$set(vm.form.partecipants[i], 'responsible_postal_code', null)
						vm.$set(vm.form.partecipants[i], 'responsible_nationality', null)
						vm.$set(vm.form.partecipants[i], 'responsible_municipality', null)
						vm.$set(vm.form.partecipants[i], 'responsible_country', null)
						vm.$set(vm.form.partecipants[i], 'responsible_province', null)			
						vm.$set(vm.form.partecipants[i], 'responsible_obj_province', null)		
						vm.$set(vm.form.partecipants[i], 'responsible_obj_municipality', null)				
					} else {
						if (! vm.form.partecipants[i].responsible_first_name) {
							vm.$set(vm.form.partecipants[i], 'responsible_first_name', vm.fiscalFile.first_name)
						}
						if (! vm.form.partecipants[i].responsible_last_name) {
							vm.$set(vm.form.partecipants[i], 'responsible_last_name', vm.fiscalFile.last_name)
						}
						if (! vm.form.partecipants[i].responsible_phone) {
							let prefix = '+39'
							let phone = ''

							if (vm.fiscalFile && vm.fiscalFile.phone) {
								const pp = vm.fiscalFile.phone.split(" ")

								if(pp && pp.length) {
									prefix = pp[0]
									if(pp.length == 2) {
										phone = pp[1]
									}
								}
							}

							vm.$set(vm.form.partecipants[i], 'responsible_phone_prefix', prefix)
							vm.$set(vm.form.partecipants[i], 'responsible_phone', phone)
						}
						if (! vm.form.partecipants[i].responsible_birthday && vm.fiscalFile.born) {
							vm.$set(vm.form.partecipants[i], 'responsible_birthday', vm.fiscalFile.born)
						}
						if (! vm.form.partecipants[i].responsible_email) {
							vm.$set(vm.form.partecipants[i], 'responsible_email', vm.fiscalFile.email)
						}
						if (! vm.form.partecipants[i].responsible_fiscal_code) {
							vm.$set(vm.form.partecipants[i], 'responsible_fiscal_code', vm.fiscalFile.fiscal_code ? vm.fiscalFile.fiscal_code.toUpperCase() : '')
						}
						if (! vm.form.partecipants[i].responsible_address) {
							vm.$set(vm.form.partecipants[i], 'responsible_address', vm.fiscalFile.address)
						}
						if (! vm.form.partecipants[i].responsible_house_number) {
							vm.$set(vm.form.partecipants[i], 'responsible_house_number', vm.fiscalFile.house_number)
						}
						if (! vm.form.partecipants[i].responsible_postal_code) {
							vm.$set(vm.form.partecipants[i], 'responsible_postal_code', vm.fiscalFile.zip)
						}
						if (! vm.form.partecipants[i].responsible_nationality) {
							vm.$set(vm.form.partecipants[i], 'responsible_nationality', vm.fiscalFile.nationality)
						}
						if (! vm.form.partecipants[i].responsible_country) {
							vm.$set(vm.form.partecipants[i], 'responsible_country', vm.fiscalFile.state)
						}
						if (! vm.form.partecipants[i].responsible_municipality) {
							vm.$set(vm.form.partecipants[i], 'responsible_municipality', vm.fiscalFile.municipality)
						}
						if (! vm.form.partecipants[i].responsible_obj_municipality) {
							vm.$set(vm.form.partecipants[i], 'responsible_obj_municipality', {
								province: {
									long_name: vm.fiscalFile.province
								},
								name: vm.fiscalFile.municipality
							})
						}

						if (! vm.form.partecipants[i].responsible_province) {
							vm.$set(vm.form.partecipants[i], 'responsible_province', vm.fiscalFile.province)
						}
						if (! vm.form.partecipants[i].responsible_obj_province) {
							vm.$set(vm.form.partecipants[i], 'responsible_obj_province', {
								long_name: vm.fiscalFile.province
							})
						}
					}
				} else {
					vm.$set(vm.form.partecipants[i], 'is_under', true)
				}
			}, 500),
			updateInvoiceData() {
				let partecipant = _.head(this.form.partecipants)

				if (partecipant.responsible_first_name) {
					let prefix = '+39'
					let phone = ''

					let pp;
					if (partecipant.responsible_first_name) {
						if(partecipant.responsible_phone) {
							pp = partecipant.responsible_phone.split(" ")
						}
					} else {
						if(partecipant.phone) {
							pp = partecipant.phone.split(" ")
						}
					}

					if(pp && pp.length) {
						prefix = pp[0]
						if(pp.length == 2) {
							phone = pp[1]
						}
					}

					this.$set(this.form.invoice_form, 'invoice_first_name', partecipant.responsible_first_name)
					this.$set(this.form.invoice_form, 'invoice_last_name', partecipant.responsible_last_name)
					this.$set(this.form.invoice_form, 'invoice_email', partecipant.responsible_email)
					this.$set(this.form.invoice_form, 'invoice_birthday', partecipant.responsible_birthday)
					this.$set(this.form.invoice_form, 'invoice_fiscal_code', partecipant.responsible_fiscal_code)
					this.$set(this.form.invoice_form, 'invoice_address', partecipant.responsible_address)
					this.$set(this.form.invoice_form, 'invoice_house_number', partecipant.responsible_house_number)
					this.$set(this.form.invoice_form, 'invoice_postal_code', partecipant.responsible_postal_code)
					this.$set(this.form.invoice_form, 'invoice_nationality', partecipant.responsible_nationality)
					this.$set(this.form.invoice_form, 'invoice_country', partecipant.responsible_country)
					this.$set(this.form.invoice_form, 'obj_municipality', partecipant.responsible_obj_municipality)
					this.$set(this.form.invoice_form, 'invoice_municipality', partecipant.responsible_municipality)
					this.$set(this.form.invoice_form, 'obj_province', partecipant.responsible_obj_province)
					this.$set(this.form.invoice_form, 'invoice_province', partecipant.responsible_province)
					this.$set(this.form.invoice_form, 'invoice_phone_prefix', prefix)
					this.$set(this.form.invoice_form, 'invoice_phone', phone)
				}
			},
			onGeoChanged({
                key,
                value,
                component
            }) {
				const isProvince = key == 'province'
				const isMunicipality = key == 'municipality'
				const isCountry = key == 'country'
				const isPrefix = key == 'prefix'

				if(component.indexOf("_invoice") > -1) {
					if(isPrefix) {
						key = 'phone_prefix'
					}

					this.$set(this.form.invoice_form, "invoice_" + key, value)

					if(isProvince) {
						this.changedProvince(value)
					} else if(isMunicipality) {
						this.changedMunicipality(value) 
					} else if(isCountry) {
						this.changedCountry(value) 
					} else if(isPrefix) {
						this.changedPrefix(value)
					}
				} else {
					const idx = parseInt(_.last(component.split("_")), 10)

					if(component.indexOf("_responsible_") > -1) {
						if(isProvince) {
							key = 'responsible_province'
						} else if(isMunicipality) {
							key = 'responsible_municipality'
						} else if(isCountry) {
							key = 'responsible_country'
						} else if(isPrefix) {
							key = 'responsible_phone_prefix'
						}

						this.$set(this.form.partecipants[idx], key, value)

						if(isProvince) {
							this.changedProvince(value, idx, true)
						} else if(isMunicipality) {
							this.changedMunicipality(value, idx, true) 
						} else if(isCountry) {
							this.changedCountry(value, idx, true) 
						} else if(isPrefix) {
							this.changedPrefix(value, idx, true)
						}
					} else {						
						if(isPrefix) {
							key = 'phone_prefix'
						}

						this.$set(this.form.partecipants[idx], key, value)

						if(isProvince) {
							this.changedProvince(value, idx)
						} else if(isMunicipality) {
							this.changedMunicipality(value, idx) 
						} else if(isCountry) {
							this.changedCountry(value, idx) 
						} else if(isPrefix) {
							this.changedPrefix(value, idx)
						}
					}
				}
            },
			changedCountry(val, idx = -1, responsible = false) {
                if(val) {
					let countryComponent
					if(idx < 0) {
						countryComponent = this.getInvoiceCountryComponent()
					} else {
						countryComponent = this.getPartecipantCountryComponent(idx, responsible)
					}
                    
                    if(countryComponent) {
                        countryComponent.setSelectedValue(val)

                        const $select = countryComponent.getSelect()
                        $select.val(val)
                    }
                }
            },
            changedProvince(val, idx = -1, responsible = false) {
                if(val) {
					let provinceComponent
					if(idx < 0) {
						provinceComponent = this.getInvoiceProvinceComponent()
					} else {
						provinceComponent = this.getPartecipantProvinceComponent(idx, responsible)
					}

                    if(provinceComponent) {
                        provinceComponent.setSelectedValue(val)

                        const $select = provinceComponent.getSelect()
                        $select.val(val)

                        const provinceSelectedId = $select.find("option").filter(function() {
                            return $(this).val() == val
                        }).data("id")

                        provinceComponent.valueChanged(provinceSelectedId)

						if(idx > -1) {
							this.$set(this.form.partecipants[idx], ( responsible ? 'responsible_' : '' ) + 'obj_province', {
								long_name: this.form.partecipants[idx][(responsible ? 'responsible_' : '') + 'province']
							})
						} else {
							this.$set(this.form.invoice_form, 'obj_province', {
								long_name: this.form.invoice_form.province
							})
						}
                    }
                }
            },
            changedMunicipality(val, idx = -1, responsible = false) {
                if(val) {
					let municipalityComponent
					if(idx < 0) {
						municipalityComponent = this.getInvoiceMunicipalityComponent()
					} else {
						municipalityComponent = this.getPartecipantMunicipalityComponent(idx, responsible)
					}
                    
                    if(municipalityComponent) {
                        municipalityComponent.setSelectedValue(val)

                        const $select = municipalityComponent.getSelect()
                        $select.val(val)

						if(idx > -1) {
							this.$set(this.form.partecipants[idx], ( responsible ? 'responsible_' : '' ) + 'obj_municipality', {
								province: {
									long_name: this.form.partecipants[idx][(responsible ? 'responsible_' : '') + 'province']
								},
								name: this.form.partecipants[idx][(responsible ? 'responsible_' : '') + 'municipality']
							})
						} else {
							this.$set(this.form.invoice_form, 'obj_municipality', {
								name: this.form.invoice_form.municipality
							})
						}
                    }
                }
            },
			changedPrefix(val, idx = -1, responsible = false) {
                if(val) {
					let phonePrefixComponent
					if(idx < 0) {
						phonePrefixComponent = this.getInvoicePhonePrefixComponent()
					} else {
						phonePrefixComponent = this.getPartecipantPhonePrefixComponent(idx, responsible)
					}

                    if(phonePrefixComponent) {
                        phonePrefixComponent.setSelectedValue(val)

                        const $select = phonePrefixComponent.getSelect()
                        $select.val(val)
                    }
                }
            },
			nextTo(view) {
				this.$set(this.form, 'view', view)

				if (view == 'confirm') {
					this.$set(this.form, 'validate_invoice', true)

					this.updateInvoiceData()
				} else {
					this.scrollOnTop()
				}
			},
			async onSubscription() {
				await this.form
					.submit('post', route('vouchers.partecipants.store', this.element))
					.then(response => {
						this.nextTo('summary')

						this.scrollOnTop()
					})
					.catch(error => {
						console.log("onSubscription")
						console.log(error)
                    })
			},	
			async onValidateSubscription() {
				await this.form
					.submit('post', route('vouchers.partecipants.validate', this.element))
					.then(async response => {
						await this.onSubscription()
					})
					.catch(error => {
						console.log("onValidateSubscription")
						console.log(error)

                        this.scrollOnTop()
                    })
			},
			async onValidateBeforeModule() {
				let partecipantIdx = this.form.partecipants.findIndex(i => i.its_me)

				if (partecipantIdx >= 0) {
					let invoice = this.form.invoice_form

					const invoice_fiscal_code = invoice.invoice_fiscal_code
					let invoice_fiscal_code_string = ''
					if (invoice_fiscal_code) {
						invoice_fiscal_code_string = invoice_fiscal_code.toString().toUpperCase()
					}
					
					this.$set(this.form.invoice_form, 'invoice_fiscal_code', invoice_fiscal_code_string)

					if (! this.form.partecipants[partecipantIdx].is_under) {
						this.$set(this.form.partecipants[partecipantIdx], 'phone', invoice.invoice_phone)
					}

					this.form.partecipants.forEach((itm, pIdx) => {
						let fc = itm.fiscal_code

						let rfc = null
						if (itm.responsible_fiscal_code) {
							rfc = itm.responsible_fiscal_code.toString().toUpperCase()
						}

						this.$set(this.form.partecipants[pIdx], 'fiscal_code', fc.toString().toUpperCase())
						this.$set(this.form.partecipants[pIdx], 'responsible_fiscal_code', rfc)
					})
				}

				await this.form
					.submit('post', route('vouchers.partecipants.validate', this.element))
					.then(response => {
						this.nextTo('modules')
					})
					.catch(error => {
						console.log("onValidateBeforeModule")
						console.log(error)

                        this.scrollOnTop()
                    })		
			}
        }
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/purchases/VoucherPartecipantsContainer.vue